import styled from 'styled-components'

export const Text = styled.span`
  font-size: 24px;
  font-weight: var(--font-medium);
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 18px;
  }
`
